import React, {useEffect} from "react";
import { connect } from "react-redux";
import {Redirect, Route, Switch, useLocation} from "react-router-dom";

import {ROUTES} from "../../../../routes";
import {setLookPageOpened} from "../../../../actions/lookFunctions";
import GroheCartLogin from "./groheCartLogin/groheCartLogin";
import GroheCartSuccess from "./groheCartPages/groheCartSuccess";
import GroheCartTerms from "./groheCartPages/groheCartTerms";
import GroheCartConfirm from "./groheCartConfirm/groheCartConfirm";
import GroheCartTwoFA from "./groheCartTwoFA/groheCartTwoFA";
import GroheCartTwoFAVerify from "./groheCartTwoFA/groheCartTwoFAVerify";
import GroheCart from "./groheCart";
import GroheCartLoginRegister from "./groheCartLogin/groheCartLoginRegister";
import GroheCartBilling from "./groheCartPayment/groheCartBilling";
import GroheCartShipping from "./groheCartPayment/groheCartShipping";
import GroheCartPayment from "./groheCartPayment/groheCartPayment";
import {getCartItemsCount} from "../groheNavigation/groheFunctions";
import GroheCartBillingInfo from "./groheCartPayment/groheCartBillingInfo";
import GroheCartDelivery from "./groheCartDelivery/groheCartDelivery";

const GroheCartRoutes = (props) => {

  const {lookPageOpened, setLookPageOpened, fabricatorData, isPhoneNumberValidated, cartItems, instList, shopPageOpened} = props;
  const fabricatorSettings = fabricatorData.settings;

  let location = useLocation();

  const sectionOpened = lookPageOpened.includes(ROUTES.cart)
    || (!shopPageOpened && !lookPageOpened && location.pathname && location.pathname.includes(ROUTES.cart));

  useEffect(() => {
    if (!lookPageOpened && location.pathname && location.pathname.includes(ROUTES.cart)) { // on cart first open after page load
      setLookPageOpened(ROUTES.cart);
    } else if (sectionOpened && (location.pathname && !location.pathname.includes(ROUTES.cart))) { // arrow back in browser
      setLookPageOpened("");
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [location.pathname]);

  const cartItemsLength = getCartItemsCount(cartItems);
  const notPassedLeadCaptureProcess = fabricatorSettings.leadCaptureShoppingCart && !isPhoneNumberValidated && !!(cartItemsLength || instList.length);

  const checkRedirect = () => {
    if (!fabricatorSettings.checkout) {
      return <Redirect to={ROUTES.home} />
    }
    if (notPassedLeadCaptureProcess && (!location.pathname || (location.pathname !== ROUTES.cart))) {
      return <Redirect to={ROUTES.cart} />
    }
    return false
  }

  return (
    <section className={"grohe-section grohe-section--large grohe-section--cart grohe-section--full" + (sectionOpened ? " grohe-section--opened" : "")}>
      <Switch>
        <Route exact path={ROUTES.cart}>
          {checkRedirect() || <GroheCart/>}
        </Route>
        <Route path={ROUTES.cartLogin}>
          <GroheCartLogin/>
        </Route>
        <Route path={ROUTES.cartRegister}>
          <GroheCartLoginRegister/>
        </Route>
        <Route path={ROUTES.cartTerms}>
          <GroheCartTerms/>
        </Route>
        <Route path={ROUTES.cartTwoFAVerify}>
          <GroheCartTwoFAVerify/>
        </Route>
        <Route path={ROUTES.cartTwoFA}>
          <GroheCartTwoFA/>
        </Route>
        <Route path={ROUTES.cartBillingInfo}>
          {checkRedirect() || <GroheCartBillingInfo/>}
        </Route>
        <Route path={ROUTES.cartBilling}>
          {checkRedirect() || <GroheCartBilling/>}
        </Route>
        <Route path={ROUTES.cartShipping}>
          {checkRedirect() || <GroheCartShipping/>}
        </Route>
        <Route path={ROUTES.cartPayment}>
          {checkRedirect() || <GroheCartPayment/>}
        </Route>
        <Route path={ROUTES.cartConfirm}>
          {checkRedirect() || <GroheCartConfirm/>}
        </Route>
        <Route path={ROUTES.cartDelivery}>
          {checkRedirect() || <GroheCartDelivery/>}
        </Route>
        <Route path={ROUTES.cartSuccess}>
          {checkRedirect() || <GroheCartSuccess/>}
        </Route>
      </Switch>
    </section>
  )
};

const mapStateToProps = (store) => {
  const {lookOpened, lookPageOpened} = store.lookState;
  const {userIsLoggedIn, isPhoneNumberValidated} = store.userState;
  const {cartItems} = store.cartState;
  const {instList} = store.instState;
  const {shopPageOpened} = store.shopState;

  return {
    lookOpened,
    lookPageOpened,
    fabricatorData: store.fabricatorState,
    userIsLoggedIn,
    isPhoneNumberValidated,
    cartItems,
    instList,
    shopPageOpened,
  };
};

const mapDispatchToProps = {
  setLookPageOpened,
};

export default connect(mapStateToProps, mapDispatchToProps)(GroheCartRoutes)
